<template>
  <div class="space-y-2">
    <!-- Compact Stats Grid -->
    <div class="grid grid-cols-2 gap-2">
      <!-- Distance -->
      <div class="bg-gray-50 dark:bg-gray-800 rounded p-2">
        <div class="text-xs text-gray-500 dark:text-gray-400 mb-0.5">Mesafe</div>
        <div class="text-sm font-semibold text-gray-900 dark:text-gray-100">{{ totalKilometer }} km</div>
      </div>

      <!-- Time -->
      <div class="bg-gray-50 dark:bg-gray-800 rounded p-2">
        <div class="text-xs text-gray-500 dark:text-gray-400 mb-0.5">Süre</div>
        <div class="text-sm font-semibold text-gray-900 dark:text-gray-100">{{ getTimeDetail(totalMinutes) }}</div>
      </div>
    </div>

    <!-- Cost Breakdown -->
    <div class="border-t border-gray-200 dark:border-gray-700 pt-2">
      <button
        type="button"
        @click="costCollapsed = !costCollapsed"
        class="w-full flex items-center justify-between text-left hover:bg-gray-50 dark:hover:bg-gray-800 rounded p-1 transition-colors"
      >
        <span class="text-xs font-medium text-gray-700 dark:text-gray-300">Maliyet</span>
        <div class="flex items-center space-x-2">
          <span class="text-xs font-semibold text-gray-900 dark:text-gray-100">{{ Money(totalCost + fuelPrice) }}₺</span>
          <i
            class="fas text-xs text-gray-400 transition-transform"
            :class="costCollapsed ? 'fa-chevron-right' : 'fa-chevron-down'"
          ></i>
        </div>
      </button>

      <div v-show="!costCollapsed" class="mt-2 space-y-1 text-xs">
        <button
          type="button"
          @click="$emit('show-toll-details')"
          class="w-full flex items-center justify-between hover:bg-gray-50 dark:hover:bg-gray-800 rounded p-1.5 transition-colors"
        >
          <span class="text-gray-600 dark:text-gray-400">Otoyol</span>
          <div class="flex items-center space-x-1">
            <span class="font-medium text-gray-900 dark:text-gray-100">{{ Money(totalCost) }}₺</span>
            <i class="fas fa-chevron-right text-xs text-gray-400"></i>
          </div>
        </button>

        <div class="flex items-center justify-between p-1.5">
          <span class="text-gray-600 dark:text-gray-400">Yakıt</span>
          <span class="font-medium text-gray-900 dark:text-gray-100">{{ Money(fuelPrice) }}₺</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RouteStatsCard',
  props: {
    totalKilometer: {
      type: Number,
      default: 0
    },
    totalMinutes: {
      type: Number,
      default: 0
    },
    totalCost: {
      type: Number,
      default: 0
    },
    fuelPrice: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      costCollapsed: false
    }
  },
  emits: ['show-toll-details'],
  methods: {
    Money(value) {
      return Number(value).toFixed(2);
    },
    getTimeDetail(minutes) {
      const hours = Math.floor(minutes / 60);
      const mins = Math.round(minutes % 60);
      return `${hours}s ${mins}dk`;
    }
  }
}
</script>